export default __webpack_public_path__ + "static/media/article-2.fb44128d.png";